import { APPLICANT_KIND } from '@flatsy/types/Applications/Applicant'
import { getLatestData } from '../Utils/GetLatestData'
import { WizardContext, WizardEvent } from '../wizardMachine'

export const isVerlingueSupportedGuarantor = (
  context: WizardContext,
  event: WizardEvent
): boolean => {
  const { application, applicants, index } = getLatestData(context, event)

  if (application && applicants && applicants[index]) {
    const applicant = applicants[index]
    if (
      applicant.kind === APPLICANT_KIND.guarantor &&
      application.is_verlingue_supported === true
    ) {
      return true
    }
  }

  return false
}
